import { render, staticRenderFns } from "./AddSingleRecipeToFolderModalContent.vue?vue&type=template&id=d54a9454&"
import script from "./AddSingleRecipeToFolderModalContent.vue?vue&type=script&lang=js&"
export * from "./AddSingleRecipeToFolderModalContent.vue?vue&type=script&lang=js&"
import style0 from "./AddSingleRecipeToFolderModalContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports